console.log("href");

export const apiUrl =
  window.location.href.includes("https://hubs.zuappointments.loop-os.com") ||
  window.location.href.includes(
    "https://appointment-react.production.theloop.tech",
  )
    ? "https://api.loopfuture.com/zu-api/api"
    : "https://appointment-springboot.stg.theloop.tech/api";
